import {IntermediatePart} from "../../intermediatePart";

export default class Decor extends IntermediatePart {
  constructor(isChild, decorCount) {
    super(isChild);
    this.decorCount = decorCount;
    this.partId = "decor_" + decorCount;
    this.partName = "Decor " + decorCount;
  }

  load(dbFeature) {
    if (dbFeature.metaData && dbFeature.metaData["ShowerSize"]) {
      this.needShowerSizeMeta = true;
    }
    return super.load_(dbFeature, new Decor(false, this.decorCount));
  }

  getArrayOfConditions() {
    const conditions = super.getArrayOfConditions();
    if (this.needShowerSizeMeta) {
      const showerParent = this.getParent().layout.parts["Shower"];
      conditions.push({
        propName: "ShowerSize",
        propValue: showerParent.showerSize()
      });
    }
    return conditions
  }

}
